import React, { useState, useEffect } from 'react';
import axios from 'axios';

const style = `
  .form-control:focus {
    background-color: transparent !important;
    box-shadow: none !important;
    border-color: #ced4da;
    outline: none !important;
  }
`;

const EditProfile = () => {
    const user = JSON.parse(localStorage.getItem('user')) || {};
    const token = localStorage.getItem('token');
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

    const [formData, setFormData] = useState({
        name: user.name || '',
        whatsapp_number: user.whatsapp_number || '',
        phone_number: user.phone_number || '',
        address: user.address || '',
        profession: user.profession || '',
        email: user.email || '',
        old_password: '',
        password: '',
        password_confirmation: '',
    });

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    useEffect(() => {
        // Inject CSS to prevent background change on focus
        const styleSheet = document.createElement("style");
        styleSheet.type = "text/css";
        styleSheet.innerText = style;
        document.head.appendChild(styleSheet);
    }, []);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        setSuccess('');

        try {
            const response = await axios.put(`${API_BASE_URL}api/customer/update`, formData, {
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    Authorization: `Bearer ${token}`
                },
            });

            if (response.data) {
                setSuccess('Profile updated successfully!');
                localStorage.setItem('user', JSON.stringify(response.data.customer));
            }
        } catch (err) {
            if (err.response && err.response.data) {
                setError(err.response.data.message || 'Something went wrong.');
            } else {
                setError('Network error.');
            }
        }

        setLoading(false);
    };

    return (
        <div className="container my-5 w-75">
            <h3>Edit Profile</h3>
            <form onSubmit={handleSubmit} className="mt-4">
                <div className="form-group mb-3">
                    <label><h5>Your Full Name:</h5></label>
                    <input
                        type="text"
                        name="name"
                        className="form-control"
                        placeholder="Full Name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="form-group mb-3">
                    <label><h5>Your WhatsApp Number:</h5></label>
                    <input
                        type="text"
                        name="whatsapp_number"
                        className="form-control"
                        placeholder="Whatsapp Number"
                        value={formData.whatsapp_number}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="form-group mb-3">
                    <label><h5>Your Phone Number:</h5></label>
                    <input
                        type="text"
                        name="phone_number"
                        className="form-control"
                        placeholder="Phone Number"
                        value={formData.phone_number}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="form-group mb-3">
                    <label><h5>Your Address:</h5></label>
                    <input
                        type="text"
                        name="address"
                        className="form-control"
                        placeholder="Address"
                        value={formData.address}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="form-group mb-3">
                    <label><h5>Your Profession Title:</h5></label>
                    <input
                        type="text"
                        name="profession"
                        className="form-control"
                        placeholder="Profession"
                        value={formData.profession}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="form-group mb-3">
                    <label><h5>Your Email:</h5></label>
                    <input
                        type="email"
                        name="email"
                        className="form-control"
                        placeholder="Email Address"
                        value={formData.email}
                        readOnly
                        disabled
                    />
                </div>

                <hr />

                <h6 className="mb-3">Change Password (optional)</h6>

                <div className="form-group mb-3">
                    {/* <label><h5>Old Password:</h5></label> */}
                    <input
                        type="password"
                        name="old_password"
                        className="form-control"
                        placeholder="Old Password"
                        value={formData.old_password}
                        onChange={handleChange}
                    />
                </div>
                <div className="form-group mb-3">
                    <input
                        type="password"
                        name="password"
                        className="form-control"
                        placeholder="New Password"
                        value={formData.password}
                        onChange={handleChange}
                    />
                </div>
                <div className="form-group mb-3">
                    <input
                        type="password"
                        name="password_confirmation"
                        className="form-control"
                        placeholder="Confirm New Password"
                        value={formData.password_confirmation}
                        onChange={handleChange}
                    />
                </div>

                {error && <p className="text-danger">{error}</p>}
                {success && <p className="text-success">{success}</p>}

                <div className="form-group">
                    <button className="btn-default" disabled={loading}>
                        {loading ? 'Saving...' : 'Update Profile'}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default EditProfile;
